import axios from "axios";
import { getCookie } from "./utils";
import { KEY_CHAIN } from "../constants";
import appConfig from "../config";

axios.interceptors.request.use(
  (config) => {
    const isInternalApi = config.url?.startsWith('/patientswebapp');
    if (isInternalApi) {
      if (appConfig.internalApiBaseUrl) {
        config.url = appConfig.internalApiBaseUrl + config.url;
      }
      const mbServerToken = getCookie(KEY_CHAIN.MB_SERVER_TOKEN) || getCookie(KEY_CHAIN.LONG_TOKEN);
      if (mbServerToken) {
        config.headers = config.headers || {};
        config.headers.mbservertoken = mbServerToken;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let GET = (url, headers, requestConfig = {}) => {
  return new Promise((resolve, reject) => {
    axios.get(url,
      {
        headers: headers ? headers : { "Content-Type": "application/json" },
        ...requestConfig,
      }
    ).then(response => {
      resolve(response.data)
      // callback(null, response.data, false);
    }).catch(err => {
      try {
        reject(err.response.data.error)
        // callback(err.response.data.error, null);
      } catch (e) {
        console.log(err);
      }
    });
  })
}

let POST = (url, data, headers, requestConfig = {}) => {
  return new Promise((resolve, reject) => {
    axios.post(url, data,
      {
        headers: headers ? headers : { "Content-Type": "application/json" },
        ...requestConfig,
      }
    ).then(response => {
      resolve(response.data);
    }).catch(err => {
      reject(err);
    });
  })
}

export {
    POST, 
    GET
}